import AddAudioModalContainer from 'components/AddAudioModal/AddAudioModalContainer'

export default {
  Container: AddAudioModalContainer,
}
